@if (newTable && dispositions?.length) {
  <ts-table [columnDefs]="columnDefs" [rowData]="dispositions" [actions]="actions"> </ts-table>
} @else {
  <table mat-table matSort [dataSource]="dispositions">
    <ng-container matColumnDef="name">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Company </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          {{ offer.name }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="due_diligence_period">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> DD Days </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          {{ offer.due_diligence_period }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="transaction_type">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Type </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          {{ offer.transaction_type | titlecase }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="closing_date">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Closing Days </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          {{ offer.closing_period }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="disposition_offer_type">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Type </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap"> Counter Offer </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="offer_price">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Price </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          <a (click)="openEditDispositionModel(offer, dispositionGroup)">{{
            offer.amount | tsCurrency: 'USD' : 'symbol' : '1.0'
          }}</a>
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="disposition_contact">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Contact </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap"> Test </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="workflow_state">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell mat-sort-header *matHeaderCellDef>
        <span class="whitespace-nowrap"> Status </span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <span class="pr-6 whitespace-nowrap">
          <a (click)="openEditDispositionModel(offer, dispositionGroup)"
            ><span
              class="inline-flex items-center font-bold text-xs px-2 py-2px rounded-full tracking-wide uppercase"
              [ngClass]="{
                'gray-200': offer.workflow_state === 'draft',
                'blue-200': offer.workflow_state === 'submitted',
                'red-200': offer.workflow_state === 'rejected',
                'green-200': offer.workflow_state === 'accepted',
              }"
            >
              <span
                class="w-2 h-2 rounded-full mr-2"
                [ngClass]="{
                  'bg-gray': offer.workflow_state === 'draft',
                  'bg-blue': offer.workflow_state === 'submitted',
                  'bg-red': offer.workflow_state === 'rejected',
                  'bg-green': offer.workflow_state === 'accepted',
                }"
              ></span>
              <span class="pr-2px leading-relaxed whitespace-nowrap">{{ offer.workflow_state | titlecase }}</span>
            </span></a
          >
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t" mat-header-cell *matHeaderCellDef>
        <span class="whitespace-nowrap">Actions</span>
      </th>
      <td mat-cell *matCellDef="let offer">
        <button
          mat-icon-button
          (click)="openEditDispositionModel(offer, dispositionGroup)"
          matTooltip="Edit"
          [appAuthorize]="NewPermission.DISPOSITIONS_EDIT"
          denyAction="disable"
        >
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button (click)="openFilesAndCommentsDrawer(offer)" matTooltip="Files and Comments">
          <mat-icon svgIcon="chevron_right"></mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr class="order-row h-16" mat-row *matRowDef="let row; columns: displayColumns"></tr>
  </table>
  <div class="empty" *ngIf="!dispositions?.length">No dispositions found</div>
}
